import type { PImage } from '../../engine/aliases'
import type { IDeadish, IEntity } from '../../entities/entitiesUtils'
import { entitiesUtils } from '../../entities/entitiesUtils-sidecar'
import { l } from '../../lib/imports'
import { createId } from '../../main/common'
import { common } from '../../main/common-sidecar'
import { sprites } from '../../sprites/sprites-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'

export enum EVoyageCarryableType {
  Default = -1,
  Null = 0,
  Coffee = 1,
  BattleRifle = 2,
}

export interface IVoyageCarryable extends IEntity, IDeadish {
  type: EVoyageCarryableType
  image: PImage
  particleTimer: number
}

const objs: IVoyageCarryable[] = []
export function getAll() {
  return objs
}

export function create(type: EVoyageCarryableType): IVoyageCarryable {
  let frame = sprites.voyTileCheckerFine1[0]
  if (type === EVoyageCarryableType.Coffee) {
    frame = sprites.voyItemCoffee[0]
  }
  if (type === EVoyageCarryableType.BattleRifle) {
    frame = sprites.voyItemBattleRifle[0]
  }

  let image = spritesUtil.createImage(voyageLayers.getLayers().shipCrew, frame)

  let id = createId()

  let obj: IVoyageCarryable = {
    id,
    idLoaded: -1,
    isDead: false,
    eType: 'voy-misc',
    image,
    particleTimer: 0,
    type,
  }
  objs.push(obj)

  return obj
}

export function moveToXY(obj: IVoyageCarryable, x: number, y: number) {
  // obj.x = x
  // obj.y = y
  obj.image.x = x
  obj.image.y = y
}

export function kill(obj: IVoyageCarryable) {
  obj.isDead = true
}
export function killAll() {
  l.forEach(objs, (c) => {
    kill(c)
  })
  removeDead()
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  removeDead()
}
export function removeDead() {
  entitiesUtils.removeDead(objs, (c) => {
    c.image.destroy()
  })
}
function update(obj: IVoyageCarryable) {
  if (obj.type === EVoyageCarryableType.Coffee) {
    let ds = common.getUpdateDelta()
    obj.particleTimer += ds
    let steamTime = 0.2
    if (obj.particleTimer > steamTime) {
      obj.particleTimer -= steamTime
      voyageParticles.create('steam', obj.image.x - 6, obj.image.y - 4)
    }
  }
}
